import React from 'react';
import { Checkbox, Space } from 'antd';
const DAYS = [
    { label: 'Mon', value: 1 },
    { label: 'Tue', value: 2 },
    { label: 'Wed', value: 3 },
    { label: 'Thu', value: 4 },
    { label: 'Fri', value: 5 },
    { label: 'Sat', value: 6 },
    { label: 'Sun', value: 0 },
];
interface DaySelectionProps {
    value?: number[];
    onChange?: (days: number[]) => void;
    disabled?: boolean;
}
const DaySelection: React.FC<DaySelectionProps> = ({ value = [1, 2, 3, 4, 5, 6], onChange, disabled }) => {
    const handleChange = (checkedValues: number[]) => {
        if (onChange) {
            onChange(checkedValues);
        }
    };
    return (
        <Checkbox.Group options={DAYS} value={value} onChange={handleChange} disabled={disabled} style={{ width: '100%' }}>
            <Space>
                {DAYS.map(day => (
                    <Checkbox key={day.value} value={day.value} disabled={disabled}>
                        {day.label}
                    </Checkbox>
                ))}
            </Space>
        </Checkbox.Group>
    );
};
export default DaySelection;
